<template>
	<!-- 支付密码设置 -->
	<div class="aboutYjBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<div class="arrImg" @click="back">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">支付密码设置</p>
				</div>
			</div>
		</van-sticky>
		<div class="xtszList">
			<div class="xtszListItem">
				<span>支付密码开关</span>
				<div>
					<van-switch v-model="checked" size="20px" active-color="#07c160" inactive-color="#ffffff" />
				</div>
			</div>
			<div class="xtszListItem" @click="passwordShowFn">
				<span>支付密码设定</span>
				<div></div>
			</div>
		</div>
		<div v-if="passwordBox" class="passwordBox">
			<!-- 密码输入框 -->
			<div class="passwordValue">
				<p>输入支付密码</p>
				<img src="../../assets/img/close.png" alt="" class="close" @click="setPasswordFn">
				<van-password-input :value="value" info="密码为 6 位数字" :focused="showKeyboard" @focus="showKeyboard = true" />
			</div>
			<!-- 数字键盘 -->
			<van-number-keyboard :show="showKeyboard" @input="onInput" @delete="onDelete" @blur="showKeyboard = false" />
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				checked: true,
				passwordBox: false,
				value: '',
				showKeyboard: true,
			};
		},
		methods: {
			onInput(checked) {
				Dialog.confirm({
					title: '提醒',
					message: '是否切换开关？',
				}).then(() => {
					this.checked = checked;
				});
			},
			back() {
				this.$router.push('/set')
			},
			passwordShowFn() {
				// this.passwordBox = true;
				this.$toast('此功能还未开启');
			},
			onInput(key) {
				this.value = (this.value + key).slice(0, 6);
				console.log(this.value)
			},
			onDelete() {
				this.value = this.value.slice(0, this.value.length - 1);
			},
			setPasswordFn(){
				this.passwordBox = false;
			}
		},
	};
</script>

<style lang="less" scoped>
	.aboutYjBox {
		background-color: #fff;
		height: 100vh;
		overflow-y: scroll;

		// 头部
		.headerBox {
			height: 160px;
			background-color: #ff4081;
			display: flex;
			background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
			background-size: 100%;
			border-bottom: 1px solid #f0f0f0;

			/*no*/
			.headerQuery {
				margin-top: 80px;
				padding: 0 16px;
				position: relative;
				display: flex;
				width: 100%;
				height: 80px;
				line-height: 80px;
				color: #000;

				.arrImg {
					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}

				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}
			}

		}

		//
		.xtszList {
			background-color: #fff;
			position: relative;

			.xtszListItem {
				margin: 0 16px;
				border-bottom: 1px solid #f0f0f0;
				/*no*/
				display: flex;
				line-height: 90px;

				span,
				div {
					flex: 1;
					font-size: 30px;
					/*px*/
				}

				>div {
					text-align: right;
					position: relative;

					.van-switch {
						position: absolute;
						top: 50%;
						right: 0;
						transform: translateY(-50%);
					}
				}
			}
		}

		.passwordBox {
			height: 100vh;
			width: 100vw;
			background-color: rgba(0, 0, 0, .4);
			overflow: hidden;
			position: fixed;
			top: 0;

			.passwordValue {
				position: absolute;
				top: 20vh;
				left: 20px;
				width: calc(100vw - 40px);
				background-color: #fff;
				border-radius: 20px;

				>p {
					text-align: center;
					line-height: 150px;
				}

				>.close {
					position: absolute;
					right: 50px;
					top: 50px;
					width: 30px;
				}

				// /deep/.van-password-input{
				// 	position: absolute;
				// 	top: 20vh;
				// 	left: 0;
				// 	width: 100vw;
				// }
			}

		}
	}
</style>
